import { render, staticRenderFns } from "./PayBoxInactive.vue?vue&type=template&id=13e8dda0&"
import script from "./PayBoxInactive.vue?vue&type=script&lang=js&"
export * from "./PayBoxInactive.vue?vue&type=script&lang=js&"
import style0 from "./PayBoxInactive.vue?vue&type=style&index=0&id=13e8dda0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13e8dda0')) {
      api.createRecord('13e8dda0', component.options)
    } else {
      api.reload('13e8dda0', component.options)
    }
    module.hot.accept("./PayBoxInactive.vue?vue&type=template&id=13e8dda0&", function () {
      api.rerender('13e8dda0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/pdv/pay-box-configuration/PayBoxInactive.vue"
export default component.exports